module.exports = __webpack_public_path__ + "img/iclr2026.1e858b94.png";